export enum FIELD_NAMES {
  COMPANIES_HOUSE_NUMBER = 'companies_house_number',
  MANAGEMENT_DOB = 'management_dob',
  ICO_PROTECTION_NUMBER = 'ico_protection_number',
  FINANCIAL_CRIME_POLICY = 'financial_crime_policy',
  DATA_PROTECTION_POLICY = 'data_protection_policy',
  TREATING_CUSTOMER_FAIRLY_POLICY = 'treating_customer_fairly_policy',
  DISASTER_RECOVERY_POLICY = 'disaster_recovery_policy',
  NUMBER_OF_COMPLAINTS_RECEIVED = 'number_of_complaints_received',
  NUMBER_OF_COMPLAINTS_UPHELD = 'number_of_complaints_upheld',
  EMPLOYEE_ACCESS_REMOVAL_PROCESS = 'employee_access_removal_process',
  PII_IN_PLACE_WITH_FCA_REQUIREMENTS = 'pii_in_place_with_fca_requirements',
  SENSITIVE_DATA_POLICY = 'sensitive_data_policy',
  ADDITIONAL_INFORMATION = 'additional_information',
  GENERAL_COMMENTS = 'general_comments',
  WHO_CARRIES_COMPLIANCE_OVERSIGHT = 'who_carries_compliance_oversight',
}

export enum FIELD_LABELS {
  COMPANIES_HOUSE_NUMBER = 'Companies House registration number',
  MANAGEMENT_DOB = 'If you are a Sole Trader and/or do not have a Companies House entry, please can you confirm the date of birth for all Senior Management/Directors within the firm',
  ICO_PROTECTION_NUMBER = 'ICO/Data protection number',
  FINANCIAL_CRIME_POLICY = 'Financial crime - including Anti-Money Laundering; Anti-Fraud; Anti-Bribery and Whistleblowing',
  DATA_PROTECTION_POLICY = 'Data protection/Cyber security',
  TREATING_CUSTOMER_FAIRLY_POLICY = 'Conduct/Treating customers fairly',
  DISASTER_RECOVERY_POLICY = 'Disaster recovery/Business continuity policy/plan',
  NUMBER_OF_COMPLAINTS_RECEIVED = 'How many regulatory investigation/adverse complaints have you or your firm received within the last 12 month period?',
  NUMBER_OF_COMPLAINTS_UPHELD = 'If you had any complaints, how many were upheld?',
  EMPLOYEE_ACCESS_REMOVAL_PROCESS = 'Is there a process in place to ensure proper removal of access to information / LiveMore Broker portal upon employee termination?',
  PII_IN_PLACE_WITH_FCA_REQUIREMENTS = 'Please confirm that PII is in place in line with the FCA’s requirements in respect of all regulated activities undertaken by your business.',
  SENSITIVE_DATA_POLICY = 'Do you have a written policy that explains to the customer how their personal sensitive data will be recorded, used, shared and stored?',
  ADDITIONAL_INFORMATION = 'Broker comments',
  WHO_CARRIES_COMPLIANCE_OVERSIGHT = "If your firm does not have an SMF 16 listed on the FCA Register and you have employees or any tied Appointed Representative's, please can you confirm who carries out your compliance oversight (particularly/but not limited to where advice is provided)?",
}

export enum POLICY_ANSWERS {
  YES = 'YES',
  NO = 'NO',
  DONT_KNOW = 'DONT_KNOW',
}

export const POLICY_ANSWERS_TEXT = {
  [POLICY_ANSWERS.YES]: 'Yes',
  [POLICY_ANSWERS.NO]: 'No',
  [POLICY_ANSWERS.DONT_KNOW]: "Don't know",
};
